import React from "react";
import "./styles.scss";

export default class CarouselItem extends React.Component {
  render() {
    const isOutlet = window.location.pathname.includes("outlet");
    const isNewVehicles = window.location.pathname.includes("usados-sin-rodar");
    const subtitle = 'Reservá tu próximo vehículo señándolo en nuestra web.';
    let title = 'Usados seleccionados';
    if (!this.props.banner) {
      if (isOutlet) {
        title = 'Outlet';
      } else if (isNewVehicles) {
        title = 'Semi nuevos';
      }
      return (
        <div className="carouselItem">
          <div className="container">
            <div className="content">
              <h1>{title}</h1>
              <p className="b">
                {subtitle}
              </p>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="carouselItem" style={{ backgroundImage: `url('http://territorioyacopini.com.ar${this.props.banner.images[0]?.path}')` }}>
        <div className="container">
          <div className="content">
            <h1>{this.props.banner.title}</h1>
            <p className="b">
              {this.props.banner.subtitle}
            </p>
          </div>
        </div>
      </div>
    );
  }
}
